export default __webpack_public_path__ + "locales/hy-AM/FillPDFDialog.json?hash=773b0d4bbcea4cfab620ce41a27cbc67";